import { useTranslation } from "react-i18next";
import { DocumentRow } from "./DocumentRow";

interface ApplicationDocumentsListProps {
  documents: any[];
  canEditFile: (doc: any) => boolean;
  onViewFile: (bucket: "profiles" | "applications", filePath: string) => void;
  onEditDocument: (doc: any) => void;
  onDeleteDocument: (documentId: number) => void;
}

export function ApplicationDocumentsList({
  documents,
  canEditFile,
  onViewFile,
  onEditDocument,
  onDeleteDocument
}: ApplicationDocumentsListProps) {
  const { t } = useTranslation();

  if (documents.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-gray-900">
        {t("common:documents.application_documents")}
      </h3>
      <div className="hidden md:grid md:grid-cols-12 md:gap-4 py-2 px-4 font-medium text-sm text-muted-foreground">
        <div className="md:col-span-4">{t("common:documents.name")}</div>
        <div className="md:col-span-3">
          {t("common:documents.document_type")}
        </div>
        <div className="md:col-span-2">
          {t("common:documents.status", "Status")}
        </div>
        <div className="md:col-span-3 text-right">
          {t("common:documents.actions")}
        </div>
      </div>
      {documents.map((doc) => (
        <DocumentRow
          key={doc.id}
          doc={doc}
          canEditFile={canEditFile}
          onViewFile={onViewFile}
          onEditDocument={onEditDocument}
          onDeleteDocument={onDeleteDocument}
        />
      ))}
    </div>
  );
}
